import api from "api";

const promotionsApi = {
    list:         (slug)           => api().get(`/establishments/${slug}/promotions`),
    create:       (slug, data)     => api().post(`/establishments/${slug}/promotions`, data),
    update:       (slug, id, data) => api().put(`/establishments/${slug}/promotions/${id}`, data),
    remove:       (slug, id)       => api().delete(`/establishments/${slug}/promotions/${id}`),
    syncProducts: (slug, id, data) => api().put(`/establishments/${slug}/promotions/${id}/products`, data),
    stats:        (slug, params)   => api().get(`/establishments/${slug}/statistics/promotions`, { params }),
};

export default promotionsApi;
